import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "@/lib/api";
import CinemaBrand from "@/components/CinemaBrand";
import { DisplayMusicByToken } from "@/components/DisplayMusic";

export default function WelcomeDisplay() {
  const { token } = useParams();
  const [d, setD] = useState(null);
  const [now, setNow] = useState(new Date());

  useEffect(() => {
    const load = () => api.get(`/displays/public/${token}`).then((r) => setD(r.data)).catch(() => {});
    load();
    const t = setInterval(load, 30000);
    const c = setInterval(() => setNow(new Date()), 1000);
    return () => { clearInterval(t); clearInterval(c); };
  }, [token]);

  if (!d) return <div className="min-h-screen flex items-center justify-center bg-black text-[#A8A398]">Lade …</div>;

  const st = d.current_showtime;
  const movie = st?.movie;
  let phase = "vor";
  let message = "";
  let target = null;
  if (st) {
    const entry = new Date(`${st.date}T${st.entry_time}:00`);
    const start = new Date(`${st.date}T${st.start_time}:00`);
    const end = st.end_time ? new Date(`${st.date}T${st.end_time}:00`) : new Date(start.getTime() + 120 * 60000);
    if (now < entry) { phase = "vor"; target = entry; message = "Einlass beginnt in"; }
    else if (now < start) { phase = "einlass"; message = "Der Einlass ist geöffnet"; target = start; }
    else if (now < end) { phase = "film"; message = "Die Vorstellung läuft"; }
    else { phase = "danach"; message = "Vielen Dank für euren Besuch"; }
  }
  const cd = target ? diff(target, now) : null;

  return (
    <div className="min-h-screen w-full relative overflow-hidden text-[#F5F0E6]">
      <DisplayMusicByToken token={token} autoStart hideToggle />
      {(st?.wallpaper_url || movie?.backdrop_url) && <img src={st?.wallpaper_url || movie?.backdrop_url} alt="" onError={(e) => { e.currentTarget.style.display = "none"; }} className="absolute inset-0 w-full h-full object-cover opacity-40" />}
      <div className="absolute inset-0 bg-gradient-to-t from-black via-black/70 to-black/30" />
      <div className="relative z-10 min-h-screen flex flex-col p-10 md:p-16">
        <div className="text-center">
          <CinemaBrand size="xl" stacked />
        </div>

        {movie ? (
          <div className="flex-1 grid lg:grid-cols-[240px_1fr_auto] gap-10 items-center mt-16">
            {movie.poster_url && <img src={movie.poster_url} alt="" className="w-56 aspect-[2/3] object-cover rounded shadow-2xl mx-auto" />}
            <div>
              <div className="text-xs uppercase tracking-[0.32em] text-[#D4AF37]">Heute</div>
              <div className="font-heading text-5xl md:text-7xl mt-2">{movie.title_de}</div>
              <div className="text-[#A8A398] mt-2 text-lg">{movie.genre} · {movie.duration_min} Min</div>
              <div className="mt-6 flex gap-8 text-lg">
                <div><div className="text-xs uppercase tracking-widest text-[#A8A398]">Einlass</div><div className="font-mono text-3xl">{st.entry_time}</div></div>
                <div><div className="text-xs uppercase tracking-widest text-[#A8A398]">Start</div><div className="font-mono text-3xl">{st.start_time}</div></div>
                <div><div className="text-xs uppercase tracking-widest text-[#A8A398]">Saal</div><div className="font-mono text-3xl">{st.hall}</div></div>
              </div>
            </div>
            <div className="text-center">
              <div className="text-xs uppercase tracking-[0.32em] text-[#A8A398]">{message}</div>
              {cd && phase !== "film" && phase !== "danach" && (
                <div className="font-mono text-6xl md:text-8xl text-[#D4AF37] mt-4 tabular-nums" data-testid="display-countdown">{cd}</div>
              )}
              {phase === "film" && <div className="font-heading text-4xl text-[#D4AF37] mt-4">🎬</div>}
              {phase === "danach" && <div className="font-heading text-4xl text-[#D4AF37] mt-4">✨</div>}
            </div>
          </div>
        ) : (
          <div className="flex-1 flex items-center justify-center">
            <div className="text-3xl text-[#A8A398] font-heading">Heute keine Vorstellung geplant.</div>
          </div>
        )}

        <div className="mt-auto flex items-end justify-between text-xs text-[#A8A398]">
          <div>{now.toLocaleTimeString("de-DE")}</div>
          <div className="text-right">Snackbar: Popcorn · Nachos · Getränke · Süßigkeiten</div>
        </div>
      </div>
    </div>
  );
}
function diff(target, now) {
  let d = target - now;
  if (d <= 0) return "00:00";
  const h = Math.floor(d / 3600000); d %= 3600000;
  const m = Math.floor(d / 60000); d %= 60000;
  const s = Math.floor(d / 1000);
  return `${h > 0 ? h + ":" : ""}${m.toString().padStart(2, "0")}:${s.toString().padStart(2, "0")}`;
}
